import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  withHandlers,
  lifecycle
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Divider from '@material-ui/core/Divider';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import {
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup
} from '@material-ui/core';
import ReactSelectMaterialUi from 'react-select-material-ui';
import PublicHeader from '../../components/PublicHeader';
import PublicFooter from '../../components/PublicFooter';
import ProgressDialog from '../../components/molecules/ProgressMobileDialog';
import RequiredButton from '../../components/atoms/RequiredButton';
import ValidationText from '../../components/atoms/ValidationText';
import { sendLogin } from '../../auth/Auth';
import { addAccountGroup, validateAccountEmail } from '../../actions/Accounts';
import { getOptionCities } from '../../actions/Cities';
import StepProgressBar from '../../components/atoms/StepProgressBar';
import GroupRegisterConfirm from '../organisms/GroupRegisterConfirm';

const styles = theme => ({
  '@global': {
    body: {
      backgroundColor: '#F7F7F7',
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
    }
  },
  main: {
    flexGrow: 1,
    maxWidth: 375,
    paddingLeft: 0,
    paddingRight: 0,
    paddingBottom: 20
    // border: '1px solid #ccc'
  },
  page: {
    paddingLeft: 15,
    paddingRight: 15
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 20
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1)
  },
  titleGroup: {
    marginTop: 20,
    marginBottom: 20,
    display: 'flex',
    alignItems: 'flex-start'
  },
  titleBlock: {
    fontWeight: 'bold',
    marginBottom: '10px'
  },
  pagerInDiv: {
    padding: 20
  },
  redText: {
    color: '#FF0000'
  },
  linkToHome: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: 20
  },
  noteText: {
    fontSize: 12,
    paddingTop: 10,
    fontWeight: 600
  },
  textLabel: {
    fontSize: 12,
    fontWeight: 600
  },
  hidden: {
    display: 'none'
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      prefectures: state.commons.prefectures,
      cities: state.cities.listCities
    }),
    dispatch => ({
      actions: bindActionCreators(
        { addAccountGroup, validateAccountEmail, getOptionCities },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('step', 'setStep', '1'),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('resultMessage', 'setResultMessage', ''),
  withState('titleMessage', 'setTitleMessage', ''),
  withState('email', 'setEmail', ''),
  withState('emailError', 'setEmailError', ''),
  withState('emailConfirmation', 'setEmailConfirmation', ''),
  withState('emailConfirmationError', 'setEmailConfirmationError', ''),
  withState('zipCode', 'setZipCode', ''),
  withState('zipCodeError', 'setZipCodeError', ''),
  withState('prefectureCode', 'setPrefectureCode', 0),
  withState('prefecturesError', 'setPrefecturesError', ''),
  withState('city', 'setCity', ''),
  withState('cityId', 'setCityId', 0),
  withState('cityIdError', 'setCityIdError', ''),
  withState('address', 'setAddress', ''),
  withState('addressError', 'setAddressError', ''),
  withState('building', 'setBuilding', ''),
  withState('phone', 'setPhone', ''),
  withState('phoneError', 'setPhoneError', ''),
  withState('groupName', 'setGroupName', ''),
  withState('groupNameError', 'setGroupNameError', ''),
  withState('groupContactName', 'setGroupContactName', ''),
  withState('groupContactNameError', 'setGroupContactNameError', ''),
  withState('department', 'setDepartment', ''),
  withState('departmentError', 'setDepartmentError', ''),
  withState('directPhone', 'setDirectPhone', ''),
  withState('directPhoneError', 'setDirectPhoneError', ''),
  withState('btnText', 'setBtnText', 'アカウント登録完了'),
  withState('haveRegistrationId', 'setHaveRegistrationId', 0),
  withState('registrationId', 'setRegistrationId', 'T'),
  withState('registrationIdError', 'setRegistrationIdError', ''),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.actions.getOptionCities();
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    checkSession,
    step,
    setStep,
    loading,
    updateLoading,
    openProgress,
    updateOpenProgress,
    resultMessage,
    setResultMessage,
    email,
    setEmail,
    emailError,
    setEmailError,
    emailConfirmation,
    setEmailConfirmation,
    emailConfirmationError,
    setEmailConfirmationError,
    zipCode,
    setZipCode,
    zipCodeError,
    setZipCodeError,
    prefectures,
    prefectureCode,
    setPrefectureCode,
    prefecturesError,
    setPrefecturesError,
    cities,
    city,
    setCity,
    cityId,
    setCityId,
    cityIdError,
    setCityIdError,
    address,
    setAddress,
    addressError,
    setAddressError,
    building,
    setBuilding,
    phone,
    setPhone,
    phoneError,
    setPhoneError,
    groupName,
    setGroupName,
    groupNameError,
    setGroupNameError,
    groupContactName,
    setGroupContactName,
    groupContactNameError,
    setGroupContactNameError,
    department,
    setDepartment,
    departmentError,
    setDepartmentError,
    directPhone,
    setDirectPhone,
    directPhoneError,
    setDirectPhoneError,
    handleRedirect,
    titleMessage,
    setTitleMessage,
    btnText,
    setBtnText,
    registrationId,
    setRegistrationId,
    registrationIdError,
    setRegistrationIdError,
    haveRegistrationId,
    setHaveRegistrationId
  }) => {
    const addParam = {
      email,
      zipCode,
      prefectureCode,
      city,
      address,
      building,
      phone,
      groupName,
      groupContactName,
      department,
      directPhone,
      registrationId: haveRegistrationId ? registrationId : undefined
    };
    const errors = {
      emailError,
      emailConfirmationError,
      zipCodeError,
      prefecturesError,
      cityIdError,
      addressError,
      phoneError,
      groupNameError,
      groupContactNameError,
      departmentError,
      directPhoneError,
      registrationIdError
    };

    useEffect(() => {
      // Scroll to top when step changed
      window.scrollTo(0, 0);
    }, [step]);

    const setCityNameData = id => {
      cities.forEach(item => {
        if (id === item.cityId) {
          setCity(item.cityName);
        }
      });
    };

    const validEmail = async () => {
      const value = email.trim();
      if (value === '') {
        setEmailError('必須項目です。');
        return 1;
      }
      if (
        !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          value
        )
      ) {
        setEmailError('メールアドレスの形式が正しくありません。');
        return 1;
      }
      const emailValidationResult = await actions.validateAccountEmail(value);
      if (
        emailValidationResult.payload &&
        emailValidationResult.payload.code === 400
      ) {
        setEmailError('メールアドレスが既に登録されています。');
        return 1;
      }
      setEmailError('');
      setEmail(value);
      return 0;
    };

    const validEmailConfirmation = () => {
      const value = emailConfirmation.trim();
      if (value === '') {
        setEmailConfirmationError('必須項目です。');
        return 1;
      }
      if (value !== email.trim()) {
        setEmailConfirmationError('メールアドレスが統一しません');
        return 1;
      }
      setEmailConfirmationError('');
      setEmailConfirmation(value);
      return 0;
    };

    const validZipCode = () => {
      const value = zipCode.trim();
      if (value === '') {
        setZipCodeError('必須項目です。');
        return 1;
      }
      if (!/^\d{7}$/.test(value)) {
        setZipCodeError('0000000形式で入力してください。');
        return 1;
      }
      setZipCodeError('');
      setZipCode(value);
      return 0;
    };

    const validPrefectures = () => {
      const value = prefectureCode;
      if (value === 0) {
        setPrefecturesError('必須項目です。');
        return 1;
      }
      setPrefecturesError('');
      setPrefectureCode(value);
      return 0;
    };

    const validCityId = () => {
      const value = cityId;
      if (value === 0) {
        setCityIdError('必須項目です。');
        return 1;
      }
      setCityIdError('');
      setCityId(value);
      return 0;
    };

    const validAddress = () => {
      const value = address.trim();
      if (value === '') {
        setAddressError('必須項目です。');
        return 1;
      }
      setAddressError('');
      setAddress(value);
      return 0;
    };

    const validPhone = () => {
      const value = phone.trim();
      if (value === '') {
        setPhoneError('必須項目です。');
        return 1;
      }
      if (!/^\d+$/.test(value)) {
        setPhoneError('数字をハイフン(-)なしで入力してください。');
        return 1;
      }
      setPhoneError('');
      setPhone(value);
      return 0;
    };

    const validGroup = () => {
      const value = groupName.trim();
      if (value === '') {
        setGroupNameError('必須項目です。');
        return 1;
      }
      setGroupNameError('');
      setGroupName(value);
      return 0;
    };

    const validGroupContactName = () => {
      const value = groupContactName.trim();
      if (value === '') {
        setGroupContactNameError('必須項目です。');
        return 1;
      }
      setGroupContactNameError('');
      setGroupContactName(value);
      return 0;
    };

    const validDepartment = () => {
      const value = department.trim();
      if (value === '') {
        setDepartmentError('必須項目です。');
        return 1;
      }
      setDepartmentError('');
      setDepartment(value);
      return 0;
    };

    const validDirectPhone = () => {
      const value = directPhone.trim();
      if (value === '') {
        setDirectPhoneError('必須項目です。');
        return 1;
      }
      if (!/^\d+$/.test(value)) {
        setDirectPhoneError('数字をハイフン(-)なしで入力してください。');
        return 1;
      }
      setDirectPhoneError('');
      setDirectPhone(value);
      return 0;
    };

    const validRegistrationId = () => {
      const value = registrationId;
      if (haveRegistrationId === 1) {
        const valueNumber = value.slice(1);
        if (!value || !valueNumber) {
          setRegistrationIdError('必須項目です。');
          return 1;
        }
        if (!/^\d+$/.test(valueNumber)) {
          setRegistrationIdError('半角数字のみ入力してください。');
          return 1;
        }
        if (valueNumber.length !== 13) {
          setRegistrationIdError('13桁の番号をご入力ください。');
          return 1;
        }
      }
      setRegistrationId(value);
      setRegistrationIdError('');
      return 0;
    };

    const valid = async () => {
      const errorCount =
        (await validEmail()) +
        validEmailConfirmation() +
        validZipCode() +
        validPrefectures() +
        validCityId() +
        validAddress() +
        validPhone() +
        validGroup() +
        validGroupContactName() +
        validDepartment() +
        validDirectPhone() +
        validRegistrationId();
      if (errorCount === 0) {
        return true;
      }
      return false;
    };

    const confirmAction = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      if (!(await valid())) {
        alert('登録情報を正しく入力してください。');
      } else {
        setCityNameData(cityId);
        setStep('2');
      }
      updateOpenProgress(false);
      updateLoading(false);
    };

    const registerAction = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      if (!(await valid())) {
        updateLoading(false);
        updateOpenProgress(false);
        alert('登録情報を正しく入力してください。');
      } else {
        const addedAccount = await actions
          .addAccountGroup(addParam)
          .then(data => checkSession(data));

        if (addedAccount.type === 'ADD_ACCOUNT_GROUP_SUCCESS') {
          setResultMessage(
            '入力したメールアドレス宛に仮パスワードを送信しましたので、メールアドレスと仮パスワードでログインしてください。'
          );
          setBtnText('アカウント登録完了');
          setTitleMessage('メールを送信しました');
          updateLoading(false);
        } else {
          setEmailError('メールアドレスが正しくありません。');
          setBtnText('閉じる');
          setResultMessage('登録に失敗しました。');
          updateLoading(false);
        }
      }
    };

    const progressOkAction = () => {
      updateOpenProgress(false);
      if (!emailError) {
        handleRedirect('/');
      }
    };

    const getCitiesOptions = () => {
      const citiesOptions = [];
      const tmpObj = { label: '', value: '0' };
      if (!prefectureCode || prefectureCode === 0) {
        cities.forEach(item => {
          citiesOptions.push({
            label: item.cityName,
            value: String(item.cityId)
          });
        });
      } else {
        cities
          .filter(
            item =>
              item.prefCode && Number(item.prefCode) === Number(prefectureCode)
          )
          .forEach(item => {
            citiesOptions.push({
              label: item.cityName,
              value: String(item.cityId)
            });
          });
      }
      return { ...citiesOptions, tmpObj };
    };

    return (
      <Container component="main" className={classes.main}>
        <CssBaseline />
        <PublicHeader />
        <div className={step !== '1' ? classes.hidden : null}>
          <div className={classes.page}>
            <div className={classes.titleGroup}>
              <Typography component="h2" variant="h5">
                グループアカウント登録
              </Typography>
            </div>

            <StepProgressBar currentStep={1} />

            <Paper className={classes.paper} elevation={1}>
              <form className={classes.form} noValidate>
                <div className={classes.pagerInDiv}>
                  <Typography variant="body2">
                    グループアカウントでは、複数店舗の売上、メニュー管理等が可能です。
                    <br />
                    こちらでご登録いただくメールアドレスは、購入・利用時の通知先として利用されます。メールアドレスは管理システムへのログイン時に必要です。
                    <br />
                    <br />
                    <span className={classes.redText}>
                      ※登録完了後、gochimeshi.com、gigi.tokyoドメインからメールが送信されます。メールを受信できるよう、あらかじめメール設定のご確認をお願いいたします。
                    </span>
                  </Typography>
                </div>
                <Divider />
                <div className={classes.pagerInDiv}>
                  <Typography variant="h6" className={classes.titleBlock}>
                    メールアドレス
                  </Typography>
                  <RequiredButton />
                  <TextField
                    required
                    label="メールアドレス"
                    placeholder="gochimeshi@gochi.com"
                    type="email"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setEmail(e.target.value);
                    }}
                    onBlur={validEmail}
                  />
                  <ValidationText message={errors.emailError} />
                  <Typography className={classes.noteText}>
                    他の店舗で使用したメールアドレスは使用できません。本メールアドレスはログイン時のIDとなります。
                  </Typography>
                </div>
                <div className={classes.pagerInDiv}>
                  <RequiredButton />
                  <TextField
                    required
                    label="メールアドレス（確認）"
                    placeholder="gochimeshi@gochi.com"
                    type="email"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setEmailConfirmation(e.target.value);
                    }}
                    onBlur={validEmailConfirmation}
                  />
                  <ValidationText message={errors.emailConfirmationError} />
                </div>
                <Divider />
                <div className={classes.pagerInDiv}>
                  <Typography variant="h6" className={classes.titleBlock}>
                    貴グループ運営会社の住所と電話番号
                  </Typography>
                  <RequiredButton />
                  <TextField
                    required
                    label="郵便番号"
                    placeholder="0001111"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setZipCode(e.target.value);
                    }}
                    onBlur={validZipCode}
                  />
                  <ValidationText message={errors.zipCodeError} />
                  <Typography className={classes.noteText}>
                    ハイフンなしで記載ください
                  </Typography>
                </div>
                <div className={classes.pagerInDiv}>
                  <TextField
                    required
                    select
                    label="都道府県"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    value={prefectureCode}
                    onChange={e => {
                      setPrefectureCode(e.target.value);
                      setCityId(Number(0));
                    }}
                    InputLabelProps={{
                      shrink: true
                    }}
                    onBlur={validPrefectures}
                  >
                    {prefectures.map(item => {
                      return (
                        <MenuItem key={item.id} value={item.id}>
                          {item.name}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                  <ValidationText message={errors.prefecturesError} />
                </div>
                <div className={classes.pagerInDiv}>
                  <ReactSelectMaterialUi
                    disabled={!prefectureCode || prefectureCode <= 0}
                    required
                    fullWidth
                    label="市区町村*"
                    className={classes.textField}
                    defaultValue={String(cityId)}
                    value={String(cityId)}
                    options={getCitiesOptions()}
                    margin="normal"
                    onChange={z => {
                      setCityId(Number(z));
                    }}
                    SelectProps={{
                      isClearable: true,
                      msgNoOptionsMatchFilter:
                        '名前が部分一致する店舗がありません'
                    }}
                    onBlur={validCityId}
                  />
                  <ValidationText message={errors.cityIdError} />
                </div>
                <div className={classes.pagerInDiv}>
                  <TextField
                    required
                    label="町域・番地"
                    placeholder="1-2-3"
                    fullWidth
                    value={address}
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setAddress(e.target.value);
                    }}
                    onBlur={validAddress}
                  />
                  <ValidationText message={errors.addressError} />
                </div>
                <div className={classes.pagerInDiv}>
                  <TextField
                    label="建物名"
                    placeholder="○○ビル 102号"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setBuilding(e.target.value);
                    }}
                    value={building}
                  />
                </div>
                <div className={classes.pagerInDiv}>
                  <RequiredButton />
                  <TextField
                    required
                    label="貴グループ電話番号"
                    placeholder="09012345678"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setPhone(e.target.value);
                    }}
                    onBlur={validPhone}
                    value={phone}
                  />
                  <ValidationText message={errors.phoneError} />
                  <Typography className={classes.noteText}>
                    ハイフンなしで記載ください
                  </Typography>
                </div>
                <Divider />
                <div className={classes.pagerInDiv}>
                  <Typography variant="h6" className={classes.titleBlock}>
                    貴グループ運営会社の連絡先
                  </Typography>
                  <RequiredButton />
                  <TextField
                    required
                    label="運営会社名"
                    placeholder="〇〇株式会社"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setGroupName(e.target.value);
                    }}
                    value={groupName}
                    onBlur={validGroup}
                  />
                  <ValidationText message={errors.groupNameError} />
                </div>
                <div className={classes.pagerInDiv}>
                  <RequiredButton />
                  <TextField
                    required
                    label="ご担当者名"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setGroupContactName(e.target.value);
                    }}
                    onBlur={validGroupContactName}
                    value={groupContactName}
                  />
                  <ValidationText message={errors.groupContactNameError} />
                </div>
                <div className={classes.pagerInDiv}>
                  <RequiredButton />
                  <TextField
                    required
                    label="所属部署"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setDepartment(e.target.value);
                    }}
                    onBlur={validDepartment}
                    value={department}
                  />
                  <ValidationText message={errors.departmentError} />
                  <Typography className={classes.noteText}>
                    個人店の場合は「なし」と記載ください
                  </Typography>
                </div>
                <div className={classes.pagerInDiv}>
                  <RequiredButton />
                  <TextField
                    required
                    label="ご担当者電話番号"
                    fullWidth
                    className={classes.textField}
                    margin="normal"
                    onChange={e => {
                      setDirectPhone(e.target.value);
                    }}
                    onBlur={validDirectPhone}
                    value={directPhone}
                  />
                  <ValidationText message={errors.directPhoneError} />
                </div>
                <div className={classes.pagerInDiv}>
                  <RequiredButton />
                  <Typography
                    component="div"
                    style={{ fontSize: 14, marginTop: 24 }}
                  >
                    インボイス制度 適格事業者登録
                  </Typography>
                  <RadioGroup
                    row
                    value={haveRegistrationId}
                    onChange={e => {
                      setHaveRegistrationId(parseInt(e.target.value, 10));
                    }}
                  >
                    <FormControlLabel
                      value={0}
                      control={<Radio color="primary" />}
                      label="未登録"
                    />
                    <FormControlLabel
                      value={1}
                      control={<Radio color="primary" />}
                      label="登録済み"
                    />
                  </RadioGroup>
                </div>
                {haveRegistrationId === 1 && (
                  <div className={classes.pagerInDiv}>
                    <RequiredButton />
                    <TextField
                      required
                      label="適格事業者登録番号"
                      fullWidth
                      className={classes.textField}
                      margin="normal"
                      name="registrationId"
                      onChange={e => {
                        if (e.target.value[0] === 'T') {
                          setRegistrationId(e.target.value);
                        } else if (!e.target.value) {
                          setRegistrationId('T');
                        }
                      }}
                      value={registrationId}
                      onBlur={validRegistrationId}
                    />
                    <ValidationText message={errors.registrationIdError} />
                    <div>Tの後に続く13桁の番号を入力してください。</div>
                  </div>
                )}
                <Divider />
                <div className={classes.pagerInDiv}>
                  <Button
                    type="button"
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                    onClick={confirmAction}
                  >
                    入力情報を確認
                  </Button>
                </div>
              </form>
            </Paper>
          </div>
          <div className={classes.linkToHome}>
            <Button
              color="primary"
              onClick={() => {
                handleRedirect('/');
              }}
            >
              ログイン画面に戻る
            </Button>
          </div>
        </div>

        {step === '2' && (
          <GroupRegisterConfirm
            addConfirm={addParam}
            registerAction={registerAction}
            handleBack={() => {
              setStep('1');
            }}
          />
        )}

        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={resultMessage}
          title={titleMessage}
          btnText={btnText}
          disableScrollLock
        />
        <PublicFooter />
      </Container>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
